(() => {
  // The section asset may be included more than once in the theme editor.
  if (window.aromaScentWheelInstalled) return;
  window.aromaScentWheelInstalled = true;
  const sized = (source, width) => {
    const url = new URL(source, document.baseURI);
    url.searchParams.set('width', width);
    return url.href;
  };
  function init(root) {
    if (root.dataset.wheelReady) return;
    root.dataset.wheelReady = 'true';
    root.querySelectorAll('[data-note-art]').forEach(art => {
      const image = art.querySelector('img');
      if (!image) return;
      const failed = () => { art.hidden = true; }; 
      image.addEventListener('error', failed);
      if (image.complete && !image.naturalWidth) failed();
    });
   
    const bottle = root.querySelector('.asw__centre img');
    if (bottle) {
      const failed = () => bottle.hidden = true;
      bottle.addEventListener('error', failed);
      if (bottle.complete && !bottle.naturalWidth) failed();
    }
    const buttons = [...root.querySelectorAll('[data-note]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const source = button.dataset.image;
      const stage = button.dataset.wheelStage;
      if (!source || !/^(?:[123]|flat)$/.test(stage || '')) return;
      const sector = root.querySelector(stage === 'flat' ? '.asw__ring' : '.asw__sector--' + stage);
      const target = sized(source, 480);
      const existing = [...(sector?.querySelectorAll('[data-note-art] img') || [])].find(img => img.src === target);
      root.querySelectorAll('[data-note-art]').forEach(item => item.classList.remove('asw__art--selected'));
      if (existing) { existing.closest('[data-note-art]').classList.add('asw__art--selected'); return; }
      const art = sector?.querySelector('[data-note-art]');
      const image = art?.querySelector('img');
      if (!image) return;
      art.classList.add('asw__art--selected');
      image.loading = 'eager';
      image.src = sized(source, 480);
      image.alt = '';
      art.hidden = false;
    }));
  }
  const scan = (scope = document) => {
    if (scope.matches?.('[data-scent-wheel]')) init(scope);
    scope.querySelectorAll('[data-scent-wheel]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
